import RoleDashboard from "./RoleDashboard";

const ROLE_LABELS = {
  ContentManager: "Content Manager",
  AcademicHead:   "Academic Head",
  Registrar:      "Registrar",
  Cashier:        "Cashier / Finance",
  HR:             "HR / Payroll",
  Librarian:      "Librarian",
  Nurse:          "Nurse / Clinic",
  GuidanceOffice: "Guidance Office",
  RegistrarStaff: "Registrar Staff",
  CashierStaff:   "Cashier Staff",
  LibraryStaff:   "Library Staff",
  ClinicStaff:    "Clinic Staff",
};

export default function GenericStaffDashboard({ user }) {
  const label = ROLE_LABELS[user?.role] || user?.role || "Staff";
  return (
    <RoleDashboard
      eyebrow={label}
      title={`Welcome${user?.linkedEntity?.displayName ? `, ${user.linkedEntity.displayName}` : `, ${user?.username || ""}`}.`}
      sub="Your role-specific tools will appear here once they are rolled out. Use the top nav for announcements, articles, and the calendar."
      user={user}
    />
  );
}
